import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { BreadcrumbItem } from './breadcrumb';

export function Breadcrumbs({
  items,
  onItemClick,
  itemRenderer,
  additionalContainerClasses,
  additionalItemClasses,
}) {
  const breadcrumbitems = itemRenderer ?
    items.map(item => (itemRenderer(item))) :
    items.map((item) => {
      // Need to make sure that onItemClick receive the proper event and item object if exists
      const onItemClickWithContext = onItemClick ? event => onItemClick(event, item) : undefined;

      return (<BreadcrumbItem
        key={item.key}
        name={item.key}
        onClick={item.onClick || onItemClickWithContext}
        href={item.href}
        text={item.text}
      />);
    });


  return (
    <div className={classnames('ba-breadcrumbs', additionalContainerClasses)}>
      <ol className={classnames('breadcrumb', additionalItemClasses)}>
        { breadcrumbitems }
      </ol>
    </div>
  );
}

Breadcrumbs.propTypes = {
  /**
   * Array of items to be displayed in the breadcrumb
   */
  items: PropTypes.arrayOf(PropTypes.shape({
    /**
    * key : Unique string associated with the breadcrumb
    */
    key: PropTypes.string.isRequired,
    /**
    * text: Text to dislay to the user for the breadcrumb
    */
    text: PropTypes.string.isRequired,
    /**
    * href: Url to navigate to when this breacrumb is clicked
    */
    href: PropTypes.string,
    /**
    * onClick: Handler fired when this breacrumb is clicked only
    * if need to have a specific action on the breadcrumb instead of the onItemClick
    */
    onClick: PropTypes.func,
  })),
  /**
   * Fired when an item in the Breadcrumbs is clicked
   * @param {object} event - clicked event
   * @param {object} item - clicked item
   * @return {void}
   */
  onItemClick: PropTypes.func,
  /**
   * Customized renderer to render a breadcrumb item
   */
  itemRenderer: PropTypes.func,
  /**
  * additionalContainerClasses: Additional class(es) to add to the breadcrumb div
  */
  additionalContainerClasses: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.array,
    PropTypes.object,
  ]),
  /**
  * additionalItemClasses: Additional class(es) to add to the breadcrumb ol
  */
  additionalItemClasses: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.array,
    PropTypes.object,
  ]),
};

Breadcrumbs.defaultProps = {
  items: [],
  onItemClick: undefined,
  itemRenderer: undefined,
  additionalContainerClasses: '',
  additionalItemClasses: '',
};
